<template>
    <div class="main" :class="{'show-main':valueSelect!=='1111'}">
        <div class="head-logo">
            <div class="head">
                <img :src="dlUrl.logo" @click.stop="showHome"/>
                <div class="head-tab">
                    <el-tabs v-model="valueSelect" @tab-click="handerChange">
                        <el-tab-pane v-for="(item,index) in optionsSelect" :key="item+index" :label="item.name" :name="String(item.id)"></el-tab-pane>
                    </el-tabs>
                </div>
                <div></div>
            </div>
        </div>
        <div class="website-container">
            <div v-if="valueSelect===this.optionsSelect[0].id" class="main-box">
                <div class="main-left">
                    <div class="left-title">
                        <img :src="dlUrl.pic_word"/>
                    </div>
                    <div class="left-icon download-wrap">
                        <div class="download item">
                            <img class="code" :src="dlUrl.code"/>
                            <div class="icon-box">
                                <img src="@/assets/images/new/apple-new@2x.png"/>
                            </div>
                            <span class="font">iOS/iPad</span>
                        </div>
                        <div class="download item">
                            <img class="code" :src="dlUrl.code"/>
                            <div class="icon-box">
                                <img src="@/assets/images/new/android@2x.png"/>
                            </div>
                            <span class="font">Android</span>
                        </div>
                        <div class="download item">
                            <div class="code">
                                <a @click="openDialogVisible('mac')"> <img :src="dlUrl.wmcode"/> </a>
                            </div>
                            <div class="icon-box ">
                                <img src="@/assets/images/new/mac@2x.png"/>
                            </div>
                            <span class="font">Mac</span>
                        </div>
                        <div class="download item">
                            <div class="code">
                                <a @click="openDialogVisible('windows')"> <img :src="dlUrl.wmcode"/> </a>
                            </div>
                            <div class="icon-box ">
                                <img src="@/assets/images/new/windows@2x.png"/>
                            </div>
                            <span class="font">Windows</span>
                        </div>
                    </div>
                </div>
                <!-- <div class="main-right" :style="'background-image:url('+dlUrl.build_app+')'"> -->
                <div class="main-right">
                    <img :src="dlUrl.build_app"/>
                    <div></div>
                </div>
            </div>
            <div class="second" v-else-if="(optionsSelect[1]&&valueSelect==optionsSelect[1].id)||(optionsSelect[3]&&valueSelect==optionsSelect[3].id)">
                <el-scrollbar style="height:100%;">
                    <div class="content-second" style="overflow-x:hide; overflow:auto;" v-html="dataWebsite.content" v-loading="loading"></div>
                    <p v-if="dataWebsite&&dataWebsite.attachmentList&&dataWebsite.attachmentList.length>0">附件</p>
                    <div class="comm-file-logo-box">
                        <div v-for="(item,index) in dataWebsite.attachmentList" :key="item+index" class="comm-file-logo">
                            <a :href="item.fileUrl" v-if="checkFileType(item.fileName)=='.pdf'" class="aimg">
                                <img src="files/image/new/wj_pdf.png"> <span>{{item.fileName}}</span>
                            </a>
                            <a :href="item.fileUrl" v-else-if="checkFileType(item.fileName)=='.docx'||checkFileType(item.fileName)=='.doc'" class="aimg">
                                <img src="files/image/new/wj_word.png"> <span>{{item.fileName.split('.')[0]}}</span>
                            </a>
                            <a :href="item.fileUrl" v-else-if="checkFileType(item.fileName)=='.png'||checkFileType(item.fileName)=='.jpeg'||checkFileType(item.fileName)=='.jpg'">
                                <img :src="item.fileUrl">
                            </a>
                            <a @click="openfile(item.fileUrl,item.fileName)" v-else-if="checkFileType(item.fileName)=='.txt'" class="aimg">
                                <img src="files/image/new/sketch.png"> <span>{{item.fileName.split('.')[0]}}</span>
                            </a>
                            <a v-else :href="item.fileUrl" class="aimg"> <img src="files/image/new/sketch.png">
                                <span>{{item.fileName.split('.')[0]}}</span>
                            </a>
                        </div>
                    </div>
                    <div class="foot">
                        <p>{{$t('copyRight')}}</p>
                    </div>
                </el-scrollbar>
            </div>
            <div class=" tried" v-else-if="valueSelect==optionsSelect[2].id">
                <el-scrollbar class="scroll" style="height:100%;">
                    <div class="hedaer">
                        <el-button
                            :class="{'show-focus':isfocus==item.id}"
                            v-for="(item,index) in secondSelect"
                            @click="secondClick(item.id)"
                            size="medium"
                            round
                            type="text"
                            plain
                            :key="index"
                        >
                            {{item.name}}
                        </el-button>
                    </div>
                    <div class="contain-tried">
                        <div class="left" v-show="treeData.length>0">
                            <!-- <el-scrollbar class="scroll" style="height:100%;"> -->
                            <el-tree
                                accordion
                                node-key="id"
                                :expand-on-click-node="true"
                                @node-click="elTreeClick"
                                ref="munuTree"
                                lazy
                                :empty-text="!treeLoading?'暂无子目录':''"
                                v-loading="treeLoading"
                                :load="loandTree"
                                :props="orgProp"
                                :data="treeData"
                                :render-content="renderContent"
                                :current-node-key="currentNodekey"
                                :default-expanded-keys="expandedkeys"
                                :highlight-current="true"
                            ></el-tree>
                            <!-- </el-scrollbar>  -->
                        </div>
                        <div class="right" :class="{'show-left':treeData.length===0}" v-if="(dataWebsite&&dataWebsite.content)||(dataWebsite&&dataWebsite.attachmentList&&dataWebsite.attachmentList.length>0)">
                            <!-- <el-scrollbar style="height:100%;" > -->
                            <div class="content" v-html="dataWebsite.content" v-loading="loading"></div>
                            <p v-if="dataWebsite&&dataWebsite.attachmentList&&dataWebsite.attachmentList.length>0">附件</p>
                            <div class="comm-file-logo-box">
                                <div v-for="(item,index) in dataWebsite.attachmentList" :key="item+index" class="comm-file-logo">
                                    <a :href="item.fileUrl" v-if="checkFileType(item.fileName)=='.pdf'" class="aimg">
                                        <img src="files/image/new/wj_pdf.png"> <span>{{item.fileName}}</span>
                                    </a>
                                    <a :href="item.fileUrl" v-else-if="checkFileType(item.fileName)=='.docx'||checkFileType(item.fileName)=='.doc'" class="aimg">
                                        <img src="files/image/new/wj_word.png">
                                        <span>{{item.fileName.split('.')[0]}}</span>
                                    </a>
                                    <a :href="item.fileUrl" v-else-if="checkFileType(item.fileName)=='.png'||checkFileType(item.fileName)=='.jpeg'||checkFileType(item.fileName)=='.jpg'">
                                        <img :src="item.fileUrl">
                                    </a>
                                    <a @click="openfile(item.fileUrl,item.fileName)" v-else-if="checkFileType(item.fileName)=='.txt'" class="aimg">
                                        <img src="files/image/new/sketch.png">
                                        <span>{{item.fileName.split('.')[0]}}</span>
                                    </a>
                                    <a v-else :href="item.fileUrl" class="aimg"> <img src="files/image/new/sketch.png">
                                        <span>{{item.fileName.split('.')[0]}}</span>
                                    </a>
                                </div>
                            </div>
                            <!-- </el-scrollbar> -->
                        </div>
                        <div class="no-data" v-else-if="!dataWebsite&&!loading||!dataWebsite.content&&!loading&&!dataWebsite.attachmentList">
                            <img src="files/image/new/no-data@2x.png" alt=""> <span>暂无详情</span>
                        </div>
                    </div>
                    <div class="foot">
                        <p>{{$t('copyRight')}}</p>
                    </div>
                </el-scrollbar>
            </div>
            <!-- <div class="main-box" v-else>帮助与反馈</div> -->
            <div class="foot-box" v-show="valueSelect===this.optionsSelect[0].id">
                <p>{{$t('copyRight')}}</p>
            </div>
        </div>
        <el-dialog :visible.sync="showTip" width="30%" center>
            <div style="text-align:center;">
                Mac版安装需进行“信任开发者”的设置，教程如下： <br/>
                <a style="color:#409EFF;" href="https://jingyan.baidu.com/article/359911f59bcbae57fe030620.html"
                >Mac如何允许安装非App Store的软件</a>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="DownloadMac">点击下载Mac版</el-button>
            </span>
        </el-dialog>
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="540px"
            :center="true"
            :before-close="cancel"
        >
            <div v-if="checks" class="dialog_oa">
                <img class="oa_img" src="../assets/images/oa@2x.png" alt="">
                <el-input class="oa_num" v-model="idValue" placeholder="请输入OA账号/工号/邮箱前缀"></el-input>
            </div>

            <div v-else class="dialog_code">
                <el-form :model="phone_form" :rules="rules" ref="ruleForm">
                    <el-form-item prop="phone">
                        <img src="../assets/images/phone.png" alt="">
                        <el-input class="phone_word" v-model="phone_form.phone" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item prop="code">
                        <img src="../assets/images/code.png" alt="">
                        <el-input class="code_word" placeholder="请输入验证码" v-model="phone_form.code"></el-input>
                        <el-button type="primary" v-show="codeShow" :disabled="!codeShow" class="code_btn" @click="sendCode">获取验证码</el-button>
                        <el-button v-show="!codeShow" disabled class="code_btn1">已发送（{{codeCount}}s）</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <Vcode :show="isShowCode" @success="success" @close="close"/>
            <el-button @click="changeCheck" size="small" class="btn_font" type="text">{{checks?'手机验证码匹配':'账号/工号匹配'}}</el-button>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel" size="small" class="cancel-btn">取消</el-button>
                <el-button v-if='checks' type="primary" :disabled="idValue==''" size="small" @click="identification">确认下载</el-button>
                <el-button v-else type="primary" :disabled="phone_form.phone==''&&phone_form.code==''" size="small" @click="checkCodeType">确认下载</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import {judge, setMeta} from "@/js/judge.js";
    import {Base64} from 'js-base64'
    import Vcode from "vue-puzzle-vcode";
    //先导入pako
    import pako from 'pako'

    export default {
        components: {
            Vcode
        },
        data() {
            const phoneValidate = (rule, value, callback) => {
                if (!value && value !== 0) {
                    return callback(new Error('手机号不能为空'))
                }
                if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(value)) {
                    return callback(new Error('请填写正确的手机号码！'))
                } else {
                    callback()
                }
            }
            const codeValidate = (rule, value, callback) => {
                if (!this.isSendCode) {
                    if (!value && value !== 0) {
                        return callback(new Error('请输入验证码'))
                    }
                    // if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(value)) {
                    //   return callback(new Error('请填写正确的手机号码！'))
                    // } else {
                    //   callback()
                    // }
                } else {
                    callback()
                }
            }
            return {
                showTip: false,
                // bg: require("@/assets/images/bg.png"),
                websiteDirectory: this.dlUrl.websiteDirectory,
                websiteContent: this.dlUrl.websiteContent,
                websiteContentZip: this.dlUrl.websiteContentZip,
                getDownloadVersion: this.dlUrl.getDownloadVersion,
                appIdCode: this.dlUrl.appIdCode,
                lang: this.dlUrl.lang,
                getCode: this.dlUrl.getCode,
                checkCode: this.dlUrl.checkCode,
                v1WebLogin: this.dlUrl.v1WebLogin,
                valueSelect: '1111',
                optionsSelect: [
                    {
                        id: '1111',
                        name: '首页'
                    }
                ],
                secondSelect: [],
                dataWebsite: {},
                pId: 0,
                mId: '',
                orgProp: {
                    children: 'children',
                    label: 'name',
                    value: 'code'
                },
                node_had: [], // 触发 tree 的 :load=loadNode 重复触发  动态更新tree
                resolve_had: [],
                scondValue: '182',
                nodeObj: {},
                treeLoading: false,
                treeData: [],
                loading: false,
                isfocus: '',
                expandedkeys: [],
                currentNodekey: '',
                dialogVisible: false,
                idValue: '',
                downloadType: '',
                downloadUrl: '',
                platform: 'Android',
                checks: true,
                phone_form: {
                    phone: '',
                    code: ''
                },
                title: '输入您的账号/工号，匹配对应版本',
                codeShow: true,
                codeCount: '',
                codeTimer: null,
                isShowCode: false,
                isSendCode: false,
                rules: {
                    phone: [
                        // { required: true, message: '请输入正整数', trigger: 'change' },
                        {validator: phoneValidate, trigger: 'blur'},
                    ],
                    code: [
                        {validator: codeValidate, trigger: 'blur'},
                    ]
                },
            };
        },
        computed: {},
        watch: {
            // pId(val){
            //   window.console.log('目录id变了',val)
            //   // this.getWebsiteDirectory()
            // },
            // mId(val){
            //   window.console.log('内容变了',val)
            // }
            'currentNodekey': function (newVal) {
                if (newVal) {
                    this.$nextTick(() => {
                        document.querySelector('.el-tree-node__content').click()
                    })
                }
            }
        },
        created() {
            this.activePath = window.sessionStorage.getItem("activePath");
        },
        mounted() {
            //设置meta
            setMeta();
            //先判断是否PC
            this.judgePC();
            //设置样式
            this.$nextTick(() => {
                this.getWebsiteDirectory()
                // let dom = document.querySelector(".main");
                // setTimeout(() => {
                //   dom.className = "main active";
                // }, 500);
            });
        },
        methods: {
            //工号还是手机号验证切换
            changeCheck() {
                // window.console.log('改变的', this.checks)
                this.checks = this.checks ? false : true
                this.title = this.checks ? '输入您的账号/工号，匹配对应版本' : '手机验证码匹配对应版本'
            },
            //发送验证码请求
            sendCode() {
                this.isSendCode = true
                this.$refs['ruleForm'].validate((valid) => {
                    // window.console.log('valid', valid)
                    if (valid) {
                        let params = {
                            appId: this.appIdCode,
                            lang: this.lang === 'zh' ? 'zh_CN' : 'en_US',
                            phone: this.phone_form.phone
                        }
                        window.console.log('params:', params)
                        // eslint-disable-next-line no-undef
                        $.ajax({
                            //请求方式
                            type: "POST",
                            //请求的媒体类型
                            contentType: "application/x-www-form-urlencoded",
                            url: this.getCode,
                            //数据，json字符串
                            data: params,
                            //请求成功
                            success: res => {
                                if (res.code == 0) {
                                    this.isSendCode = false
                                    this.isShowCode = true
                                    this.dialogVisible = false
                                    // window.console.log('获取验证码成功', res)
                                    this.$message.success(res.msg)
                                } else {
                                    this.$message.error(res.msg);
                                }
                            },
                            //请求失败，包含具体的错误信息
                            error: error => {
                                window.console.log('error:', error)
                                this.$message.error(error.msg)
                                this.isSendCode = false
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            // 用户通过了滑块验证
            success() {
                this.isShowCode = false; // 通过验证后，需要手动隐藏模态框
                this.dialogVisible = true
                const TIME_COUNT = 60;
                if (!this.codeTimer) {
                    this.codeCount = TIME_COUNT;
                    this.codeShow = false;
                    this.codeTimer = setInterval(() => {
                        if (this.codeCount > 0 && this.codeCount <= TIME_COUNT) {
                            this.codeCount--;
                        } else {
                            this.codeShow = true;
                            clearInterval(this.codeTimer);
                            this.codeTimer = null;
                        }
                    }, 1000)
                }
            },
            // 用户点击遮罩层，应该关闭模态框
            close() {
                this.isShowCode = false;
                this.dialogVisible = true
            },
            //验证验证码请求
            checkCodeType() {
                this.isSendCode = true
                this.$refs['ruleForm'].validate((valid) => {
                    // window.console.log('valid', valid)
                    if (valid) {
                        let params = {
                            isPhone: this.checks ? 0 : 1,
                            appId: this.appIdCode,
                            lang: this.lang === 'zh' ? 'zh_CN' : 'en_US',
                            phone: this.phone_form.phone,
                            code: this.phone_form.code,
                            src: 1
                        }
                        // window.console.log('params:', params)
                        // eslint-disable-next-line no-undef
                        $.ajax({
                            //请求方式
                            type: "POST",
                            //请求的媒体类型
                            contentType: "application/x-www-form-urlencoded",
                            url: this.checkCode,
                            //数据，json字符串
                            data: params,
                            //请求成功
                            success: res => {
                                if (res.code == 0) {
                                    this.isSendCode = false
                                    // window.console.log('校验验证码成功', res)
                                    this.$message.success(res.msg)
                                    this.v1WebLoginType()
                                } else {
                                    this.$message.error(res.msg)
                                }
                            },
                            //请求失败，包含具体的错误信息
                            error: error => {
                                window.console.log('error:', error)
                                this.$message.error(error.msg)
                                this.isSendCode = false
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            openDialogVisible(type) {
                this.dialogVisible = true
                if (type == 'mac') {
                    this.downloadType = 'mac'
                    this.platform = 6
                } else if (type == 'windows') {
                    this.downloadType = 'windows'
                    this.platform = 5
                }
            },
            //手机验证的确认下载
            v1WebLoginType() {
                this.downloadUrl = ''
                let params = {
                    appId: this.appIdCode,
                    isPhone: this.checks ? 0 : 1,
                    phone: this.phone_form.phone,
                    platform: this.platform
                }
                // eslint-disable-next-line no-undef
                $.ajax({
                    //请求方式
                    type: "POST",
                    //请求的媒体类型
                    contentType: "application/x-www-form-urlencoded",
                    url: this.v1WebLogin,
                    //数据，json字符串
                    data: params,
                    //请求成功
                    success: res => {
                        window.console.log('res', res)
                        if (res.code == 0 && res.data.url) {
                            if (this.downloadType == 'mac') {
                                this.showTip = true
                                this.dialogVisible = false
                                this.downloadUrl = res.data.url
                            } else {
                                window.location.href = res.data.url;
                                this.dialogVisible = false
                            }
                            this.idValue = ''
                            this.platform = ''
                            this.$message.success(res.msg)
                        } else {
                            this.$message.error(res.msg)
                        }
                    },
                    //请求失败，包含具体的错误信息
                    error: error => {
                        window.console.log('error:', error)
                        this.$message.error(error.msg)
                    }
                });
            },
            //工号、账号的确认下载
            identification() {
                this.downloadUrl = ''
                let params = {
                    appId: 'Ti9f1nQ7',
                    account: this.idValue,
                    platform: this.platform
                }
                // eslint-disable-next-line no-undef
                $.ajax({
                    //请求方式
                    type: "POST",
                    //请求的媒体类型
                    contentType: "application/x-www-form-urlencoded",
                    url: this.getDownloadVersion,
                    //数据，json字符串
                    data: params,
                    //请求成功
                    success: res => {
                        window.console.log('res', res)
                        if (res.code == 0 && res.data.url) {
                            if (this.downloadType == 'mac') {
                                this.showTip = true
                                this.dialogVisible = false
                                this.downloadUrl = res.data.url
                            } else {
                                window.location.href = res.data.url;
                                this.dialogVisible = false
                            }
                            this.idValue = ''
                            this.platform = ''
                            this.$message.success(res.msg)
                        } else {
                            this.$message.error(res.msg)
                        }
                    },
                    //请求失败，包含具体的错误信息
                    error: error => {
                        window.console.log('error:', error)
                        this.$message.error(error.msg)
                    }
                });
            },
            cancel() {
                this.dialogVisible = false
                this.idValue = ''
                this.downloadType = ''
                this.platform = ''
            },
            /*
            *** 树点击操作
              */
            elTreeClick(data, node, value) {
                window.console.log('data:', data, "node：", node, "value:", value)
                this.mId = data.id
                // document.querySelector('.el-tree-node__content').style.color = "#00B6FF";
                this.getWebsiteContent()
            },
            //下载Mac包
            DownloadMac() {
                window.location.href = this.downloadUrl;
                this.showTip = false;
            },
            //判断PC
            judgePC() {
                //判断pc
                if (!judge()) {
                    this.$router.push({path: "/mobile"});
                }
            },
            /**ios的登陆 */
            submitLog() {},
            /**获取官网一级目录 */
            getWebsiteDirectory() {
                this.dataWebsite = {}
                // window.console.log('this1', this.optionsSelect)
                let that = this
                this.$axios.get(this.websiteDirectory, {
                    //请求的媒体类型
                    contentType: "application/x-www-form-urlencoded",
                    params: {id: this.pId},
                }).then(res => {
                    window.console.log('res', res)
                    if (res.data.code == 0) {
                        let data = JSON.parse(JSON.stringify(res.data.data))
                        if (data.length > 0) {
                            that.optionsSelect.push(...data)
                            let obj1 = {}
                            let peen = that.optionsSelect.reduce((cur, next) => {
                                obj1[next.id] ? "" : obj1[next.id] = true && cur.push(next);
                                return cur;
                            }, [])
                            that.optionsSelect = peen
                        } else {
                            this.getWebsiteContent()
                        }
                    } else {
                        // this.$message.error("获取目录失败!");
                    }
                }).catch(function (error) {
                    window.console.log(error);
                }).finally(() => {
                    // this.treeLoading = false
                })
            },
            /**获取官网二级目录 */
            getScondWebsite() {
                // window.console.log('this.secondSelect', this.secondSelect)
                this.secondSelect = []
                let that = this
                this.$axios.get(this.websiteDirectory, {
                    //请求的媒体类型
                    contentType: "application/x-www-form-urlencoded",
                    params: {id: this.pId},
                }).then(res => {
                    // window.console.log('res', res)
                    if (res.data.code == 0) {
                        let data = JSON.parse(JSON.stringify(res.data.data))
                        if (data.length > 0) {
                            that.secondSelect.push(...data)
                            let obj1 = {}
                            let peen = that.secondSelect.reduce((cur, next) => {
                                obj1[next.id] ? "" : obj1[next.id] = true && cur.push(next);
                                return cur;
                            }, [])
                            that.secondSelect = peen
                            if (this.valueSelect == this.optionsSelect[2].id) {
                                this.secondClick(that.secondSelect[0].id)
                            }
                            // window.console.log('that.secondSelect', that.secondSelect)
                        } else {
                            this.getWebsiteContent()
                        }
                    } else {
                        // this.$message.error("获取目录失败!");
                    }
                }).catch(function (error) {
                    window.console.log(error);
                }).finally(() => {
                    // this.treeLoading = false
                })
            },
            /**三级及以后目录tree的节点加载事件 */
            loandTree(node, resolve) {
                // window.console.log('二级目录', node)
                if (!node.key) {
                    return
                }
                this.treeLoading = true
                if (node.key == this.secondSelect[0].id) {
                    // window.console.log('二级目录')
                    this.treeLoading = true
                    this.treeData = []
                }
                let that = this
                this.$axios.get(this.websiteDirectory, {
                    //请求的媒体类型
                    contentType: "application/x-www-form-urlencoded",
                    params: {id: node.key},
                }).then(res => {
                    window.console.log('res', res)
                    if (res.data.code == 0) {
                        let data = JSON.parse(JSON.stringify(res.data.data))
                        if (data.length > 0) {
                            // window.console.log('添加目录返回来的数据为：', JSON.stringify(data, null, 4))
                            // window.console.log('this.dataWebsite:', this.dataWebsite)
                            for (var i = 0; i < that.secondSelect.length; i++) {
                                if (node.key == that.secondSelect[i].id) {
                                    that.treeData = [...data]
                                }
                            }
                            that.node_had = node;
                            that.resolve_had = resolve;
                            // window.console.log('that.treeData:', that.treeData)
                            that.resolve_had([...data])
                        } else {
                            // this.treeData=[]
                            // that.mId = node.key
                            // that.getWebsiteContent()
                            // that.resolve_had([])
                        }
                        // eslint-disable-next-line no-undef
                        $('.el-icon-loading').css('display', 'none')
                        that.treeLoading = false
                    } else {
                        that.treeLoading = false
                    }
                }).catch(function (error) {
                    window.console.log(error);
                    that.treeLoading = false
                }).finally(() => {
                    that.treeLoading = false
                })
            },
            /**一级目录点击事件 */
            handerChange(e) {
                // window.console.log('一级的点击e,this.valueSelect', e, '---', this.valueSelect)
                if (this.valueSelect !== '1111') {
                    this.pId = this.valueSelect
                    this.mId = this.valueSelect
                    this.getScondWebsite()
                }
            },
            /*开发文档 二级目录点击事件 */
            secondClick(e) {
                // window.console.log('二级的点击', e)
                this.pId = e
                this.mId = e
                this.dataWebsite = {}
                if (e) {
                    // window.console.log('this.scondValue', e)
                    this.nodeObj = {key: e}
                    this.treeData = []
                    this.loandTree(this.nodeObj, this.resolve_had)
                }
                this.$nextTick(() => {
                    this.isfocus = e
                    // this.getWebsiteContent()
                    this.getWebsiteContent(data => {
                        // window.console.log('data==callback:', data)
                        if (!data.content && !data.attachmentList) {
                            this.currentNodekey = this.treeData[0].id
                            this.expandedkeys.push(this.treeData[0].id)
                            this.$refs.munuTree.setCurrentKey(0)
                        } else {
                            this.currentNodekey = ''
                        }
                    })
                })
            },
            /**官网获取目录内容 */
            getWebsiteContent(callback) {
                // this.dataWebsite={}
                let that = this
                that.loading = true
                this.$axios.get(this.websiteContentZip, {
                    //请求的媒体类型
                    header: {
                        contentType: "application/x-www-form-urlencoded;charset=UTF-8",
                    },
                    params: {dId: this.mId},
                }).then(res => {
                    // window.console.log('res', res)
                    if (res.data.code == 0) {
                        let data = res.data.data
                        if (data) {
                            // this.$message.success("登录成功!");
                            let gzip = this.unZip(data)
                            // window.console.log('目录内容',JSON.parse(gzip))
                            let pzip = JSON.parse(gzip)
                            that.dataWebsite = pzip
                            // window.console.log('content', pzip)
                            // var attachmentList = []
                            that.dataWebsite.content = pzip.content ? Base64.decode(pzip.content) : ''
                            if (callback) {
                                callback(that.dataWebsite)
                            }
                            // if(pzip&&pzip.attachmentList&&pzip.attachmentList.length>0){
                            //   for (var i=0;i<that.dataWebsite.attachmentList.length;i++){
                            //     var splitURL = (that.dataWebsite.attachmentList[i].fileUrl).split('/')
                            //     splitURL[3]=that.dataWebsite.attachmentList[i].fileName
                            //     var urlName = splitURL.join('/')
                            //     window.console.log('name',urlName)
                            //     attachmentList.push({
                            //       fileUrl:urlName,
                            //       fileName:that.dataWebsite.attachmentList[i].fileName
                            //     })
                            //   }
                            //   window.console.log('attachmentList',attachmentList)
                            //   that.dataWebsite.attachmentList = attachmentList
                            // }
                        }
                    } else {
                        // this.$message.error("获取目录失败!");
                    }
                }).catch(function (error) {
                    window.console.log(error);
                }).finally(() => {
                    that.loading = false
                })
            },
            // b64Data-->传入加密的数据进行解密
            unZip(key) {
                var charData = [];
                var keyArray = key.split('');
                for (var i = 0; i < keyArray.length; i++) {
                    var item = keyArray[i];
                    charData.push(item.charCodeAt(0));
                }
                var data = pako.inflate(charData);
                // 如果字符太大，会导致内存溢出报错，这里使用分片处理
                var str = '';
                var chunk = 8 * 1024
                var j;
                for (j = 0; j < data.length / chunk; j++) {
                    str += String.fromCharCode.apply(null, data.slice(j * chunk, (j + 1) * chunk));
                }
                str += String.fromCharCode.apply(null, data.slice(j * chunk));
                return decodeURIComponent(Base64.decode(str));
            },
            /** 保存链接的激活状态*/
            saveNavStart(activePath) {
                window.sessionStorage.setItem("activePath", activePath);
                this.activePath = activePath;
            },
            /**附件的文件类型获取 */
            checkFileType(fileType) {
                // window.console.log('filetyle',Base64.decode(fileType.split('/')[3]))
                fileType.substr(fileType.lastIndexOf('.'), fileType.length)
                let type = fileType.substr(fileType.lastIndexOf('.'), fileType.length).toLowerCase()
                window.console.log('reg', type)
                return type
            },
            showHome() {
                this.valueSelect = this.optionsSelect[0].id
            },
            openfile(url, name) {
                // eslint-disable-next-line no-console
                console.log('url,name', url, '===', name)
                let that = this
                this.$axios.get(url, {
                    //请求的媒体类型
                    header: {
                        contentType: "application/x-www-form-urlencoded;charset=UTF-8",
                    },
                }).then(res => {
                    window.console.log('res:', res, name)
                    let filename
                    filename = name
                    const fileName = filename;//下载文件名称
                    const tmpDown = new Blob([res.data]);
                    const a = document.createElement('a');
                    a.href = URL.createObjectURL(tmpDown);
                    a.download = fileName;
                    a.click();

                }).catch(function (error) {
                    window.console.log(error);
                }).finally(() => {
                    that.loading = false
                })
            },
            /**改变树目录的样式 */
            renderContent(h,{node,data,store}){
                // window.console.log('render-data:',data,"store:",store)
                if(data.level == 3){
                    return(
                        <span class="custom-tree-node tree-node-3" style="display:flex;width:90%;line-height:40px;font-size:16px;font-family: PingFangSC-Regular, PingFang SC !important;font-weight:500;">
                            <span style="width:200px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{node.label}</span>
                            <span>{(node.childNodes.length>0&&!node.expanded)?(<i class="el-icon-arrow-right"></i>):(node.childNodes.length>0&&node.expanded)?(<i class="el-icon-arrow-down"></i>):(<i class="el-icon-arrow-right"></i>)}</span>
                        </span>
                    )
                }else{
                    return(
                        <span class="custom-tree-node tree-node-4" style="display:flex;width:100%;line-height:40px;font-size:14px;font-family: PingFangSC-Regular, PingFang SC !important;font-weight:400;">
                            <span style="width:180px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">{node.label}</span>
                            <span>{(node.childNodes.length>0&&!node.expanded)?(<i class="el-icon-arrow-right"></i>):(node.childNodes.length>0&&node.expanded)?(<i class="el-icon-arrow-down"></i>):''}</span>
                        </span>
                    )
                }
            },
        },
    };
</script>
<style lang="scss" scoped>
    /deep/ .el-button--text {
        margin-left: 52px !important;
    }

    .btn_font {
        color: #00B6FF !important;
    }

    .dialog-footer {
        .el-button {
            min-width: 100px;
        }

        .cancel-btn {
            background-color: #e8e8e8;
            color: #616161;
        }
    }

    .dialog_oa {
        width: 385px;
        height: 40px;
        margin: 10px auto 5px;

        img {
            display: inline-block;
            width: 16px !important;
            height: 16px !important;
            position: absolute;
            top: 102px;
            left: 83px;
            z-index: 1;
        }

        /deep/ .oa_num {
            padding: 0 10px;
            background: #FEFEFE;
            border-radius: 4px;
            border: 1px solid #DEDEDE;

            input {
                background: transparent;
            }

            /deep/ .el-input__suffix {
                margin-right: 7px;
                margin-top: -1px;

                .el-input__icon:before {
                    font-size: 13px;
                }
            }
        }

        .oa_num {
            position: relative;
        }

        /deep/ ::-webkit-input-placeholder {
            font-size: 14px;
            color: #999999;
        }

        /deep/ .el-form-item {
            margin-bottom: 20px;
        }

        // /deep/.el-form-item__content{
        //   margin-left:0 !important;
        // }
        /deep/ .el-input__inner {
            border: 0;
            border-radius: 0;
            // border-bottom: 1px solid #d9d9d9;
            font-size: 16px;
            color: #666666;
            padding-left: 0px 29px;
            // height: 26px;
            /deep/ &::-webkit-input-placeholder {
                color: #BFBFBF;
            }
        }

        /deep/ .el-input {
            width: 100% !important;
        }

        /deep/ .el-input__prefix {
            left: 0;
        }

        /deep/ .el-input--prefix {
            .el-input__inner {
                padding-left: 37px;
            }
        }

        /deep/ .el-input__suffix {
            right: -4px;
        }
    }

    .dialog_code {
        width: 385px;
        margin: 10px auto 5px;
        // margin: 10px auto;
        img {
            display: inline-block;
            width: 16px !important;
            height: 16px !important;
            position: absolute;
            top: 12px;
            left: 7px;
            z-index: 10;
        }

        /deep/ .phone_word, .code_word {
            // box-shadow: 0px 0px 8px 0px rgba(25,54,90,0.02), 0px 4px 5px 0px rgba(25,54,90,0.04);
            // border-radius: 16px;
            // border: 1px solid rgba(240,240,240,1);
            background: #FEFEFE;
            border-radius: 4px;
            border: 1px solid #DEDEDE;
            padding: 0 10px;

            input {
                background: transparent;
            }

            /deep/ .el-input__suffix {
                margin-right: 7px;
                margin-top: -1px;

                .el-input__icon:before {
                    font-size: 13px;
                }
            }
        }

        .phone_word {
            position: relative;
            z-index: 1;
            width: 385px;
            height: 40px;
            // margin-bottom: 12px;
        }

        // .phone_num{
        //   position: absolute;
        // }
        /deep/ ::-webkit-input-placeholder {
            font-size: 14px;
            color: #999999;
        }

        .code_word {
            background: transparent;
            user-select: none;
            // border: 0;
            // border-radius: 0;
            // border-bottom: 1px solid #d9d9d9;
            font-size: 16px;
            color: #666666;
            // padding-left: 0px;
            // width: 100%;
            width: 263px;
            height: 40px;
            // padding: 0;
            outline: none;
            // height: 34px;
            position: relative;
            // margin-left:30px;
            z-index: 1;

            /deep/ .el-input__suffix {
                margin-right: 30px;
            }

            &::-webkit-input-placeholder {
                color: #BFBFBF;
            }
        }

        .code_btn {
            position: absolute;
            // right: 10px;
            margin-left: 12px;
            z-index: 1;
            width: 110px;
            height: 40px;
            background: linear-gradient(145deg, #F6FCFF 0%, #EDFAFF 100%);
            border-radius: 4px;
            border: 1px solid #DDF0F8;
            color: #39ADFA;

        }

        .code_btn1 {
            position: absolute;
            // right: 10px;
            margin-left: 12px;
            z-index: 1;
            width: 110px;
            height: 40px;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #CCCCCC;
            line-height: 18px;
            // background: linear-gradient(145deg, #F6FCFF 0%, #EDFAFF 100%);
            // border-radius: 4px;
            // border: 1px solid #DDF0F8;
        }

        /deep/ .el-form-item {
            margin-bottom: 24px;
        }

        // /deep/.el-form-item__content{
        //   margin-left:0 !important;
        // }
        /deep/ .el-input__inner {
            border: 0;
            border-radius: 0;
            // border-bottom: 1px solid #d9d9d9;
            font-size: 16px;
            color: #666666;
            padding-left: 0px 10px;
            // height: 26px;
            /deep/ &::-webkit-input-placeholder {
                color: #BFBFBF;
            }
        }

        /deep/ .el-input {
            // width:100% !important;
        }

        /deep/ .el-input__prefix {
            left: 0;
        }

        /deep/ .el-input--prefix {
            .el-input__inner {
                padding-left: 37px;
            }
        }

        /deep/ .el-input__suffix {
            right: -4px;
        }

    }
</style>
<style lang="scss" scoped>
    html,
    body {
        margin: 0;
        padding: 0;
        font-family: PingFangSC-Regular, PingFang SC !important;

    }

    html,
    body,
    .main {
        height: 100%;
        overflow: -Scroll;
        overflow-x: hidden
    }

    .main {
        background-size: cover;
        background: #F5F8FA;
        position: relative;

        .left-title {
            img {
                transform: none;
                opacity: 1;
            }
        }

        .foot-box {
            transform: none;
            opacity: 1;
        }

        .main-right {
            height: 100%;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column;
            -webkit-box-pack: space-evenly;
            -ms-flex-pack: space-evenly;
            justify-content: space-evenly;

            img {
                transform: scale(1);
                opacity: 1;
                object-fit: contain;
                display: inline-block;
                width: 100%;
                height: 100%;
            }
        }

        .download-wrap,
        .head-logo img {
            opacity: 1;
        }
    }

    .show-main {
        background-size: cover;
        font-family: PingFangSC-Regular, PingFang SC !important;
        position: relative;
        background: #fff;

        .left-title {
            img {
                transform: none;
                opacity: 1;
            }
        }

        .foot-box {
            transform: none;
            opacity: 1;
        }

        .main-right {
            height: 100%;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column;
            -webkit-box-pack: space-evenly;
            -ms-flex-pack: space-evenly;
            justify-content: space-evenly;

            img {
                transform: scale(1);
                opacity: 1;
                object-fit: contain;
                display: inline-block;
                width: 100%;
                height: 100%;
            }
        }

        .download-wrap, .head-logo img {
            opacity: 1;
        }
    }

    .download-wrap {
        opacity: 0;
        transition: all 1s ease-in-out;

        .item {
            float: left;
            margin-right: 1.25%;
            box-sizing: border-box;
        }
    }

    .download {
        position: relative;

        .code {
            position: absolute;
            left: 0px;
            top: 0px;
            visibility: hidden;
            opacity: 0;
            transition: all 0.5s ease-in-out;
            width: 108px;
            height: 108px;
            display: inline-block;
            background: #ffffff;
            display: table-cell;
            vertical-align: middle;
            text-align: center;

            img {
                margin-top: 30%;
                width: 36px;
                height: 36px;
                display: inline-block;
            }
        }

        &:hover {
            .code {
                visibility: visible;
                opacity: 1;
            }
        }

        .font {
            position: absolute;
            left: 54px;
            top: 130px;
            transform: translateX(-50%);
            visibility: visible;
            opacity: 1;
            transition: all 0.5s ease-in-out;
            display: table-cell;
            vertical-align: middle;
            text-align: center;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC !important;
            font-weight: 400;
            color: #666666;
        }
    }

    .icon-box {
        display: inline-block;
        width: 108px;
        height: 108px;
        background: #ffffff;
        display: table-cell;
        vertical-align: middle;
        text-align: center;

        img {
            width: 36px;
            height: 36px;
            display: inline-block;
        }
    }

    .website-container {
        margin: 0 auto;
        padding: 0;
        width: 70%;
        height: 100%;
        min-width: 1200px;
    }

    .head-logo {
        width: 100%;
        background: #F5F8FA;
        min-height: 86px;
        height: 8%;

        .head {
            margin: 0 auto;
            padding: 0;
            width: 70%;
            height: 100%;
            min-width: 1200px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            background: #F5F8FA;

            .head-tab {
                margin-top: 26px;
            }
        }

        img {
            display: block;
            width: 27%;
            display: inline-block;
            width: 111px;
            height: 54px;
            margin-top: 16px;
            opacity: 0;
            transition: all 1s ease-in-out;
        }
    }

    .main-left {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
    }

    .main-right {
        flex: 1;

        img {
            display: inline-block;
            width: 100%;
            object-fit: contain;
            transform: scale(0.3);
            transition: all 0.5s ease-in-out;
            opacity: 0;
        }
    }

    .left-title {
        display: block;

        img {
            width: 80%;
            height: auto;
            transform: translate(-20px, -20px);
            transition: all 0.5s ease-in-out;
            opacity: 0;
        }
    }

    .main-box {
        display: flex;
        align-items: center;
        height: 70%;
        margin-top: 5%;
        min-width: 1200px;

    }

    .second {
        margin-top: 0;
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: hidden;
        display: inline-block;
        height: 89%;
        width: 100%;

        .content-second {
            min-height: 730px;
            height: 95%;
            padding: 32px 16px 0px 16px;
            overflow: hidden;
            letter-spacing: 1px;
            word-break: break-all;
            overflow-wrap: break-word;

            p {
                width: 100%;
                word-break: break-word;
            }

            /deep/ table {
                width: 100% !important;
                word-break: break-word;
            }

            /deep/ .MsoTableGrid {
                width: 100% !important;
                word-break: break-word;
            }

            /deep/ .syntaxhighlighter {
                width: 100% !important;
                word-break: break-word;
            }
        }

        p {
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC !important;
            font-weight: 400;
            color: #A0A0A0;
            line-height: 20px;
            letter-spacing: 1px;
            margin-top: 16px;
            margin-bottom: 16px;
            padding: 0px 16px 0px 16px;
        }

        .comm-file-logo-box {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin-bottom: 16px;
            padding: 0px 16px 0px 16px;

            .comm-file-logo {
                margin-left: 16px;
                margin-top: 8px;
                display: flex;
                align-items: center;
                justify-content: center;

                .aimg {
                    width: 104px;
                    height: 104px;
                    border-radius: 6px;
                    border: 1px solid #CBCBCB;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;

                    span {
                        display: inline-block;
                        width: 84px;
                        margin-left: 5px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    img {
                        width: 32px;
                        height: 32px;
                        cursor: pointer;
                    }
                }

                img {
                    width: 104px;
                    height: 104px;
                    cursor: pointer;
                }

                span {
                    font-size: 12px;
                    color: #666;
                }
            }

            .get-file-style {
                position: absolute;
                top: 0;
                left: 0;
                display: block;
                text-align: center;
                height: 48px;
                line-height: 48px;
                width: 100%;
                z-index: 100;
                background: #fff;
                font-size: 11px;
                border-radius: 10px;
                color: #2c9bf4;
            }
        }

        img {
            display: inline-block;
            width: 100%;
        }

        .foot {
            height: 32px;
            width: 100%;
            line-height: 16px;
            text-align: center;
            opacity: 1;
            transform: translateY(20px);
            transition: all 0.5s ease-in-out;

            p {
                font-size: 50%;
                color: #A0A0A0;;
            }
        }
    }

    .tried {
        display: flex;
        flex-direction: column;
        background-color: #ffffff;
        height: 89%;
        margin-top: 0;
        min-width: 1000px;

        .el-tabs__nav-wrap::after {
            background-color: #fff;
        }

        .hedaer {
            margin-top: 10px;
            padding-bottom: 10px;
            height: 8%;
            width: 100%;
            text-align: center;
            border-bottom: 1px solid #ebeef0;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;

            .show-focus {
                color: #00B6FF;
                background: #ECF9FF;
            }

        }

        .contain-tried {
            width: 100%;
            height: 85%;
            min-height: 730px;
            display: flex;
            flex-direction: row;

            .left {
                width: 22%;
                min-width: 260px;
                height: 100%;
                white-space: nowrap;
                padding: 16px 16px 16px 24px;
                border-right: 1px solid #F0F0F0;;

                .scroll {
                    display: inline-block;
                    height: 100%;
                    width: 100%;
                }
            }

            .right {
                width: 70%;
                height: 100%;
                padding: 16px 0px 16px 16px;
                letter-spacing: 1px;
                word-break: break-all;
                overflow-wrap: break-word;

                .content {
                    display: inline-block;
                    height: 100%;
                    width: 100%;
                    overflow: hidden;
                    letter-spacing: 1px;
                    word-break: break-all;
                    overflow-wrap: break-word;

                    p {
                        width: 100%;
                        word-break: break-word;
                    }

                    /deep/ table {
                        width: 100% !important;
                        word-break: break-word;
                    }

                    /deep/ .container {
                        width: 100% !important;
                        word-break: break-word;
                    }

                    /deep/ .MsoNormal {
                        width: 100% !important;
                        word-break: break-word;

                        span {
                            width: 100% !important;
                            word-break: break-word !important;
                            white-space: pre-line !important;
                            font-family: PingFangSC-Regular, PingFang SC !important;
                        }
                    }

                    /deep/ .MsoTableGrid {
                        width: 100% !important;
                        word-break: break-word;
                    }

                    /deep/ .syntaxhighlighter {
                        width: 100% !important;
                        word-break: break-word;
                    }
                }

                p {
                    height: 20px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC !important;
                    font-weight: 400;
                    color: #A0A0A0;
                    line-height: 20px;
                    letter-spacing: 1px;
                    margin-top: 16px;
                    margin-bottom: 16px;
                }

                .comm-file-logo-box {
                    display: flex;
                    align-items: center;
                    margin-bottom: 16px;
                    flex-wrap: wrap;

                    .comm-file-logo {
                        margin-left: 16px;
                        margin-top: 8px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .aimg {
                            width: 104px;
                            height: 104px;
                            border-radius: 6px;
                            border: 1px solid #CBCBCB;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;

                            span {
                                display: inline-block;
                                width: 84px;
                                margin-left: 5px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }

                            img {
                                width: 32px;
                                height: 32px;
                                cursor: pointer;
                            }
                        }

                        img {
                            width: 104px;
                            height: 104px;
                            cursor: pointer;
                        }

                        span {
                            font-size: 12px;
                            color: #666;
                        }
                    }

                    .get-file-style {
                        position: absolute;
                        top: 0;
                        left: 0;
                        display: block;
                        text-align: center;
                        height: 48px;
                        line-height: 48px;
                        width: 100%;
                        z-index: 100;
                        background: #fff;
                        font-size: 11px;
                        border-radius: 10px;
                        color: #2c9bf4;
                    }
                }

                img {
                    display: inline-block;
                    width: 100%;
                }

            }

            .show-left {
                width: 100%;
            }

            .no-data {
                width: 76%;
                height: 100%;
                padding: 16px 24px 16px 24px;
                margin: auto;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                img {
                    width: 320px;
                    height: 164px;
                }

                span {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC !important;
                    font-weight: 400;
                    color: #CBCBCB;
                    line-height: 20px;
                }
            }
        }

        .foot {
            height: 32px;
            width: 100%;
            line-height: 16px;
            text-align: center;
            opacity: 1;
            transform: translateY(20px);
            transition: all 0.5s ease-in-out;

            p {
                font-size: 50%;
                color: #A0A0A0;;
            }
        }

    }

    ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #000000;
        border-radius: 3px;
    }

    .foot-box {
        height: 16px;
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 16px;
        text-align: center;
        opacity: 0;
        transform: translateY(20px);
        transition: all 0.5s ease-in-out;

        p {
            font-size: 50%;
            color: #A0A0A0;;
        }
    }

    .left-icon {
        height: 50%;
        margin-top: 10%;

        p {
            width: 100%;
            height: 10%;
            font-size: 1vw;
            font-family: PingFangSC-Regular, PingFang SC !important;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 10%;
            text-align: left;
            margin-bottom: 10%;
        }
    }

    .icon-box {
        min-width: 10%;
        min-height: 10%;
        transition: background-color ease-in-out 0.5s;

        &:hover {
            background: rgba(255, 255, 255, 0.2);
        }

        a {
            display: block;
            width: 100%;
        }
    }

    @media only screen and (max-width: 1500px) {
        .download .code {
            width: 108px;
            height: 108px;
        }
        .left-icon {
            height: 50%;
            margin-top: 5%;

            p {
                margin-bottom: 5%;
            }
        }
        .download-wrap {
            .item {
                width: 108px;
            }
        }

    }

    @media only screen and (max-width: 1400px) {
        .download .code {
            width: 108px;
            height: 108px;
        }
        .left-icon {
            height: 50%;
            margin-top: 5%;

            p {
                margin-bottom: 5%;
            }
        }
        .download-wrap {
            .item {
                width: 108px;
            }
        }
    }

    @media only screen and (max-width: 1300px) {
        .main-box, .second, .tried {
            min-width: 500px;

            .content-second, .contain-tried {
                min-height: 580px;
            }
        }
        .download .code {
            width: 108px;
            height: 108px;
        }
        .download-wrap {
            .item {
                width: 108px;
            }
        }
        .left-title {
            img {
                width: 85%;
            }
        }
    }

    @media only screen and (max-width: 1920px) {
        .main-box, .second, .tried {
            .content-second, .contain-tried {
                min-height: 750px;
            }
        }
    }

    @media only screen and (max-width: 1440px) {
        .main-box, .second, .tried {
            .content-second, .contain-tried {
                min-height: 590px;
            }
        }
    }
</style>
<style>
    body {
        font-family: PingFangSC-Regular, PingFang SC !important;
    }

    img {
        width: 100%;
    }

    .el-tree {
        font-family: PingFangSC-Regular, PingFang SC !important;
        font-weight: 400;
        color: #333333;
    }

    .el-tree-node__content {
        height: 40px;
    }

    .tree .el-tree-node__expand-icon.expanded {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    .tree .el-icon-caret-right:before {
        content: "\E602";
    }

    .tree .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
        content: "\E63c";
    }

    .el-tree-node:focus > .el-tree-node__content {
        background-color: #fff !important;
        color: #00B6FF !important;
    }

    .el-tree /deep/ .el-tree-node__expand-icon.expanded {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    /* //有子节点 且未展开 */
    .el-tree /deep/ .el-icon-caret-right:before {
        content: '';
        display: block;
        width: 16px;
        height: 16px;
        background-size: 16px;
    }

    /* //有子节点 且已展开 */
    .el-tree /deep/ .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
        content: '';
        display: block;
        width: 16px;
        height: 16px;
        background-size: 16px;
    }

    /* //没有子节点 */
    .el-tree /deep/ .el-tree-node__expand-icon.is-leaf::before {
        content: '';
        display: block;
        width: 16px;
        height: 16px;
        background-size: 16px;
    }

    a {
        text-decoration: none;
    }

    .el-scrollbar__wrap {
        overflow-x: hidden;
    }

    .el-button--text {
        color: #494949;
    }

    .el-tabs__header {
        margin: 0 0 0px;
    }

    .el-tabs__item {
        font-size: 1rem;
        font-weight: 500;
        color: #383838;
        font-family: PingFangSC-Regular, PingFang SC !important;
    }

    .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
        color: #00B6FF;
        font-weight: bold;
    }

</style>
